import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import styles from '../NewUserWizard.module.css';

const MOCK_REVIEWS = [
  {
    reviewer: 'Sarah M.',
    stars: 5,
    review: 'Amazing service! Very professional and friendly.',
    reply: 'Thank you Sarah! We\'re thrilled to hear that…',
    status: 'replied',
  },
  {
    reviewer: 'John D.',
    stars: 3,
    review: 'Good overall but could be a bit faster.',
    reply: 'Hi John, thank you for your honest feedback…',
    status: 'pending',
  },
  {
    reviewer: 'Aisha K.',
    stars: 5,
    review: 'Highly recommend! Will definitely come back.',
    reply: 'Thank you Aisha, we look forward to seeing…',
    status: 'replied',
  },
];

const Stars = ({ count }) => (
  <span className={styles.stars} aria-label={`${count} stars`}>
    {'★'.repeat(count)}{'☆'.repeat(5 - count)}
  </span>
);

const StepReviewTour = ({ onNext }) => {
  const { t } = useLanguage();

  const callouts = [
    { cls: 'calloutStar',   emoji: '⭐', label: t('step4CalloutStar', 'Customer star rating') },
    { cls: 'calloutReview', emoji: '💬', label: t('step4CalloutReview', 'Their review text') },
    { cls: 'calloutReply',  emoji: '🤖', label: t('step4CalloutReply', 'AI-drafted reply') },
    { cls: 'calloutStatus', emoji: '✅', label: t('step4CalloutStatus', 'Pending = needs approval') },
  ];

  return (
    <div>
      <div className={styles.stepTag}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 3v18h18" /><path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" />
        </svg>
        {t('step4Tag', 'Dashboard tour')}
      </div>

      <h2 className={styles.wizardTitle}>{t('wizardStep4Title', 'Your review dashboard')}</h2>
      <p className={styles.wizardSubtitle}>
        {t('step4Sub', "Here's exactly what you'll see once reviews start coming in:")}
      </p>

      {/* Callout legend */}
      <div className={styles.calloutGrid}>
        {callouts.map((c, i) => (
          <span key={i} className={`${styles.calloutBadge} ${styles[c.cls]}`}>
            {c.emoji} {c.label}
          </span>
        ))}
      </div>

      {/* Mock table */}
      <table className={styles.mockTable} aria-label="Sample reviews table preview">
        <thead>
          <tr>
            <th>#</th>
            <th>{t('reviewerCol', 'Reviewer')}</th>
            <th>⭐ {t('ratingCol', 'Rating')}</th>
            <th>💬 {t('reviewCol', 'Review')}</th>
            <th>🤖 {t('replyCol', 'Reply Draft')}</th>
            <th>✅ {t('statusCol', 'Status')}</th>
          </tr>
        </thead>
        <tbody>
          {MOCK_REVIEWS.map((r, i) => (
            <tr key={i}>
              <td style={{ color: '#9ca3af', fontSize: '0.75rem' }}>{i + 1}</td>
              <td><span className={styles.reviewerName}>{r.reviewer}</span></td>
              <td><Stars count={r.stars} /></td>
              <td><span className={styles.reviewText}>{r.review}</span></td>
              <td><span className={styles.replyText}>{r.reply}</span></td>
              <td>
                {r.status === 'replied' ? (
                  <span className={styles.badgeReplied}>
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                    {t('statusRepliedBadge', 'Replied')}
                  </span>
                ) : (
                  <span className={styles.badgePending}>
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /><circle cx="5" cy="12" r="1" /></svg>
                    {t('statusPendingBadge', 'Pending')}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{ fontSize: '0.78rem', color: '#9ca3af', marginTop: 10, textAlign: 'center' }}>
        {t('step4SampleNote', 'Sample data for illustration — your real reviews will appear here.')}
      </p>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <button type="button" className={styles.btnPrimary} onClick={onNext}>
          {t('step4UnderstandBtn', 'I understand')}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StepReviewTour;
